import React, { FC } from "react";
import { WidgetValuePicker, WidgetValuePickerChildrenProps } from "./WidgetValuePicker";
import { Input, Select } from "@xapp/components";
import style from "./style.scss";

export interface WidgetLengthPickerProps {
    readonly value: string | undefined;
    readonly defaultValue: string | undefined;
    readonly required?: boolean;
    readonly disabled?: boolean;
    onChange(value: string): void;
}

const items = [
    { label: "em", value: "em" },
    { label: "px", value: "px" },
    { label: "rem", value: "rem" },
    { label: "%", value: "%" }
];

export const WidgetLengthPickerRaw: FC<WidgetValuePickerChildrenProps<string>> = ({
    value,
    required,
    override,
    disabled,
    onChange
}: WidgetValuePickerChildrenProps<string>) => {

    const re = /(\d*\.?\d+)([a-zA-Z%]*)/;
    const parts = value ? value.match(re) : undefined;
    const num = value ? (parts ? parts[1] : "") : "";
    const unit = parts ? parts[2] : "px";

    function handleNumChange(s: string) {
        const n = Number(s);

        if (isNaN(n)) {
            return;
        }

        onChange(`${n}${unit}`);
    }

    function handleUnitChange(u: string) {
        onChange(`${num}${u}`);
    }

    return (
        <div style={{ display: "flex", alignItems: "end" }}>
            <Input
                className={style.lengthPickerValue}
                type="number"
                value={num}
                disabled={override}
                onChange={(value: string) => handleNumChange(value)} />
            <Select
                items={items}
                className={style.lengthPickerUnit}
                value={unit} disabled={override || disabled}
                onChange={handleUnitChange} />
        </div>
    );
};

export const WidgetLengthPicker: FC<WidgetLengthPickerProps> = props => {
    return (
        <div className={style.lengthPicker}>
            <WidgetValuePicker<string>
                value={props.value}
                defaultValue={props.defaultValue}
                children={WidgetLengthPickerRaw}
                disabled={props.disabled}
                onChange={props.onChange}
                required={props.required}
            />
        </div>
    );
};